import { render, staticRenderFns } from "./Device.vue?vue&type=template&id=f6a1eb48&scoped=true"
var script = {}
import style0 from "./Device.vue?vue&type=style&index=0&id=f6a1eb48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a1eb48",
  null
  
)

export default component.exports